import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import StandardsList from './views/StandardsList.vue'
import Auth from './components/Auth.vue';
import AuthSuccess from './components/AuthSuccess.vue';
import Dashboard from './views/Dashboard.vue';
import UnitPlan from './views/UnitPlan.vue';
import WeeklyPlan from './views/WeeklyPlan.vue';
import UnitPlanPrintView from './views/UnitPlanPrintView.vue';
import store from './store/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if(store.getters.isLoggedIn)
          next('/dashboard')
        else
          next('/auth')
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/standards',
      name: 'standards-list',
      component: StandardsList
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/unit-plan/:id',
      name:'unit-plan',
      component: UnitPlan,
      children: [
        {
          path: 'week/:weeknum',
          name: 'unit-plan-week',
          component: WeeklyPlan
        }
      ]
    },
    {
      path: '/unit-plan/:id/print',
      name:'unit-plan-print',
      component: UnitPlanPrintView
    },
    { path: '/auth', component: Auth },
    { path: '/success', component: AuthSuccess }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js